/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { LadderChallenge } from './LadderChallenge';
import {
    LadderChallengeFromJSON,
    LadderChallengeFromJSONTyped,
    LadderChallengeToJSON,
    LadderChallengeToJSONTyped,
} from './LadderChallenge';

/**
 * 
 * @export
 * @interface GetLadderChallengesResponse
 */
export interface GetLadderChallengesResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetLadderChallengesResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<LadderChallenge>}
     * @memberof GetLadderChallengesResponse
     */
    challenges: Array<LadderChallenge>;
}

/**
 * Check if a given object implements the GetLadderChallengesResponse interface.
 */
export function instanceOfGetLadderChallengesResponse(value: object): value is GetLadderChallengesResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('challenges' in value) || value['challenges'] === undefined) return false;
    return true;
}

export function GetLadderChallengesResponseFromJSON(json: any): GetLadderChallengesResponse {
    return GetLadderChallengesResponseFromJSONTyped(json, false);
}

export function GetLadderChallengesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLadderChallengesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'challenges': ((json['challenges'] as Array<any>).map(LadderChallengeFromJSON)),
    };
}

export function GetLadderChallengesResponseToJSON(json: any): GetLadderChallengesResponse {
    return GetLadderChallengesResponseToJSONTyped(json, false);
}

export function GetLadderChallengesResponseToJSONTyped(value?: GetLadderChallengesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'challenges': ((value['challenges'] as Array<any>).map(LadderChallengeToJSON)),
    };
}

